/** Shared nav row height — primary rail + configure panel (Figma NavItem) */
export const sidebarNavRowHeightClassName = 'h-[38px]';

/** Collapsed icon-rail — Figma Side Nav: 48×38, centered icon */
export const sidebarNavItemIconOnlyClassName =
  'w-[48px] shrink-0 justify-center !px-0 gap-0';

/**
 * Shared Figma sidebar nav row (node 2391:17522 / Left Nav 3042:34140)
 * Default: transparent · Active/hover: Grey/100 #E7E7E7 · dark: Grey/100 @ 10% · radius 6px · h 38
 */
export const sidebarNavItemClassName =
  'flex h-[38px] w-full cursor-pointer items-center gap-3 rounded-[6px] px-4 transition-colors hover:bg-[#E7E7E7] dark:hover:bg-[var(--sidebar-pill-dark)] disabled:cursor-not-allowed disabled:opacity-50 group-data-[collapsible=icon]:w-[48px] group-data-[collapsible=icon]:justify-center group-data-[collapsible=icon]:!px-0 group-data-[collapsible=icon]:gap-0';

export const sidebarNavItemActiveClassName =
  'bg-[#E7E7E7] dark:bg-[var(--sidebar-pill-dark)]';

/** Figma section/tree rows — full 264px bleed (scroll area px-4 + pr-0.5) */
export const sidebarSectionItemRowClassName =
  'group relative -ml-4 -mr-[1.125rem] flex h-[38px] w-[calc(100%+2.125rem)] min-w-0 cursor-pointer items-center gap-3 overflow-hidden rounded-[6px] px-4 text-left transition-colors hover:bg-[#E7E7E7] dark:hover:bg-[var(--sidebar-pill-dark)]';
